/* Court Vibes, 18.09.2026. Vorabladen der Zielseiten.

   Warum: am 18.09.2026 gemessen ist eine Kollektionsseite rund 1.242.000
   Zeichen HTML gross, der reine Abruf dauerte im Test zwischen 600 und 1100
   Millisekunden. Der Server antwortet schon nach rund 62 Millisekunden, die
   Zeit steckt fast vollstaendig in der Uebertragung. Deshalb fuehlt sich
   jeder Klick auf einen Filterknopf oder einen Menuepunkt traege an.

   Loesung: Speculation Rules. Sobald Maus oder Finger einen Link beruehren,
   holt Chrome die Zielseite im Hintergrund. Beim Klick liegt sie schon da.

   Bewusst nur "prefetch", nicht "prerender": prefetch laedt das HTML, fuehrt
   aber kein Skript der Zielseite aus. So zaehlt die Shopify-Statistik keine
   Aufrufe, die nie stattgefunden haben. Prerender waere schneller, wuerde
   aber die Zahlen im Bericht verfaelschen.

   eagerness "moderate" heisst: am Rechner beim Schweben, am Handy beim
   Antippen, hoechstens zwei Seiten gleichzeitig, nie blind im Voraus.

   Ausgenommen: Warenkorb, Kasse, Konto, App-Pfade, Datendateien, fremde
   Fenster und alles mit der Klasse cv-nicht-vorabladen.

   Bei eingeschaltetem Datensparmodus oder sehr langsamer Verbindung
   passiert nichts, dort waere das Vorabladen eine Zumutung.

   Safari und Firefox kennen Speculation Rules nicht, dort bleibt alles wie
   vorher. Faellt die Datei aus, ebenfalls: es geht nichts kaputt.

   Probe im Browser:
   getComputedStyle(document.documentElement).getPropertyValue('--cv-vorabladen')
*/
(function () {
  if (!(HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;

  var v = navigator.connection;
  if (v && (v.saveData === true || /^(slow-2g|2g)$/.test(v.effectiveType || ''))) return;

  var regeln = {
    prefetch: [
      {
        where: {
          and: [
            { href_matches: '/*' },
            {
              not: {
                href_matches: [
                  '/cart*',
                  '/checkout*',
                  '/account*',
                  '/apps/*',
                  '/tools/*',
                  '/*.json*',
                  '/*.atom*'
                ]
              }
            },
            {
              not: {
                selector_matches: 'a[rel~="nofollow"], a[target="_blank"], .cv-nicht-vorabladen'
              }
            }
          ]
        },
        eagerness: 'moderate'
      }
    ]
  };

  function setzen() {
    var s = document.createElement('script');
    s.type = 'speculationrules';
    s.textContent = JSON.stringify(regeln);
    (document.head || document.documentElement).appendChild(s);
    document.documentElement.style.setProperty('--cv-vorabladen', 'on');
  }

  if (document.head) {
    setzen();
  } else {
    document.addEventListener('DOMContentLoaded', setzen);
  }
})();